/* eslint-disable no-dupe-keys */
export default {
  charge_point: {
    name: '充电桩',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '桩名',
      serial_number: '桩编号',
      nameplate_number: '桩铭牌号',
      connector_type: '采集模块',
      charging_stack_sn: '堆编号',
      charger_brand: '品牌',
      product_model: '产品型号',
      rated_voltage: '额定电压',
      rated_current: '额定电流',
      rated_power: '额定功率',
      is_auto_billing: '桩计费',
      minimum_turn_on_balance: '最低启动金额',
      minimum_charging_balance: '停止保留余额',
      business_status: '运营状态',
      description: '描述',
      equipment_type: '硬件设备类型',
      manufacture_date: '出厂日期',
      warranty_expired_date: '维保到期时间',
      password: '桩密码',
      chargers_count: '单桩的枪数',
      has_ready_status: '有插枪状态',
      charging_standard: '充电标准',
      charger_name: '枪名',
      module_latest_healthy_time: '模块最近健康时间',
      billing_type: '计费类型',
      charge_station: '充电站',
      service_provider: '运营商',
      warranty_status: '维保状态',
      firmware_version: '固件版本',
      charger_brand: '品牌',
      charger: '充电枪',
      created_at: '创建时间',
      updated_at: '更新时间',
      province_id: '省份',
      city_id: '城市',
      charger_device_sn: '采集器编号',
      propagate_serial_number_to_chargers: '修改编号，会自动同步充电枪编号'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    // Enum的属性
    charging_standards: {
      national_standard: '国标',
      european_standard: '欧标'
    },
    charge_name_options: ['A枪', 'B枪', 'C枪', 'D枪', '一号枪', '二号枪', '三号枪', '四号枪'],
    connector_types: {
      meter: '电表',
      universal: '电桩'
    },
    validates: {
      invalid_charge_points: '桩名称、桩编号设置有误不能重复或为空'
    },
    equipment_types: {
      dc_equipment: '直流',
      ac_equipment: '交流',
      split_equipment: '直流分体式'
    },
    billing_types: {
      platform_billing: '平台计费',
      device_billing: '桩计费'
    },
    warranty_statuses: {
      none: '无质保',
      expired: '质保过期',
      available: '在保'
    },
    titles: {
      base_info: '基本信息',
      device_prop: '硬件属性',
      business_info: '运营信息',
      charger_info: '充电枪信息',
      select_ref_charge_point: '选择参考的充电桩',
      select_equipment: '请选择设备',
      other_info: '其他信息'
    },
    // 占位提示
    group_titles: {
      base_info: '公共信息',
      batch_charger: '每个桩的信息'
    },
    labels: {
      copy_ref: '复制参考桩',
      select_equipment_production: '选择已出厂设备',
      charge_points: '电站下的桩',
      show_all_charge_points: '显示所有桩'
    },
    list_tabs: {
      all: '全部',
      ac_equipment: '交流',
      dc_equipment: '直流',
      closed: '已下架'
    },
    detail_tags: {
      detail: '基本信息',
      billing_rule: '费率'
    },
    placeholder: {
      search_keyword: '请输入桩编号/堆编号',
      select_warranty_status: '请选择维保状态',
      select_charging_standard: '请选择充电标准',
      search_firmware_version: '请输入固件版本',
      search_station: '输入要查找的充电站'
    },
    qrcode_dialog: {
      title: '充电桩二维码'
    }
  }
}
